export const isGradeOnlyRubric = (rubric) => (
  Boolean(rubric?.grade_only || rubric?.display_mode === 'grade_only' || rubric?.score_internal_only)
);

export const isGradeOnlyResult = (result, rubric = null) => (
  Boolean(
    result?.grade_only ||
    result?.display_mode === 'grade_only' ||
    result?.score_internal_only ||
    isGradeOnlyRubric(rubric)
  )
);

export const getItemLevel = (item) => (
  item?.matched_level ||
  item?.level ||
  item?.grade ||
  ''
);

export const getGradeOnlySummary = (result, fallback = '등급') => {
  const topLevel = result?.matched_level || result?.grade;
  if (topLevel) return String(topLevel);

  const levels = (result?.item_scores || [])
    .map(getItemLevel)
    .filter(Boolean);
  if (levels.length === 0) return fallback;

  const counts = levels.reduce((acc, level) => {
    acc[level] = (acc[level] || 0) + 1;
    return acc;
  }, {});
  const sorted = Object.entries(counts).sort((a, b) => b[1] - a[1]);
  if (sorted.length === 1) return sorted[0][0];
  return sorted.map(([level, count]) => `${level} ${count}`).join(' · ');
};

export const getGradeOnlyDistribution = (results = []) => {
  const counts = {};
  results.forEach((result) => {
    if (!result || result.error) return;
    const summary = getGradeOnlySummary(result, '').split(' · ')[0].split(' ')[0];
    if (!summary) return;
    counts[summary] = (counts[summary] || 0) + 1;
  });
  return Object.entries(counts)
    .sort((a, b) => b[1] - a[1])
    .map(([level, count]) => `${level} ${count}`)
    .join(' · ');
};

export const formatScoreOrGrade = (result, rubric = null, fallback = '등급') => {
  if (isGradeOnlyResult(result, rubric)) {
    return getGradeOnlySummary(result, fallback);
  }
  const score = Array.isArray(result?.item_scores) && result.item_scores.length > 0
    ? result.item_scores.reduce((sum, item) => sum + (Number(item?.score) || 0), 0)
    : (result?.total_score ?? result?.score ?? 0);
  return `${score}점`;
};
